<template>
    <div class="group flex gap-4 py-5">
        <img v-if="episode.image" :src="episode.image" :alt="episode.title" loading="lazy" class="hidden h-24 w-24 shrink-0 rounded-md object-cover sm:block" />
        <div class="min-w-0 flex-1">
            <h3 class="font-semibold leading-snug text-white">
                <Link :href="'/episode/' + episode.id" class="hover:underline">{{ episode.title }}</Link>
            </h3>
            <p v-if="episode.excerpt" class="mt-1 line-clamp-2 text-sm text-nomad-400">{{ episode.excerpt }}</p>
            <div class="mt-3 flex items-center gap-4">
                <button @click="prepareCurrent({ id: episode.id, type: 'EPISODE', title: episode.title || episode.name })"
                    class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-sm text-black transition-transform hover:scale-105"
                    aria-label="Play Episode">
                    <span class="icon-play translate-x-px"></span>
                </button>
                <span class="text-xs text-nomad-400">
                    {{ episode.pubDate }}<template v-if="episode.source && episode.source[0] && episode.source[0].length"><span class="mx-1">·</span>{{ episode.source[0].length }}</template>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { Link } from "@inertiajs/vue3";
import { mapState, mapActions } from "vuex";
export default {
    name: "EpisodeCard",
    props: {
        episode: Object,
    },
    components: {
        Link,
    },
    methods: {
        ...mapActions("current", ["prepareCurrent"]),
    },
};
</script>
